// extracted by mini-css-extract-plugin
export var resizer = "_hm-0";